import React from 'react'
import AppBody from '../components/app/AppBody'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'

const AppDevelopment = () => {
  return (
    <div>
      <Navbar></Navbar>
      <AppBody></AppBody>
      <Footer></Footer>
    </div>
  )
}

export default AppDevelopment
